export default "__VITE_ASSET__mTxotCyT__"